import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight, Sparkles } from "lucide-react";

/**
 * CategoryOverviewCard — used in the "All categories overview" grid on /services.
 * Clicking activates the corresponding tab and scrolls to the detail section.
 */
export default function CategoryOverviewCard({ category, index, icons, onPick }) {
    const Icon = icons[category.icon] || Sparkles;
    const handleClick = () => {
        onPick(category.id);
        window.setTimeout(() => {
            document
                .getElementById("services-category-detail")
                ?.scrollIntoView({ behavior: "smooth", block: "start" });
        }, 80);
    };

    return (
        <motion.button
            type="button"
            onClick={handleClick}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.5, delay: index * 0.05 }}
            className="group text-left glass rounded-3xl border border-white/5 p-7 brand-border-hover tracing-beam"
            data-testid={`service-overview-card-${category.id}`}
        >
            <div className="flex items-start justify-between">
                <div className="inline-flex h-11 w-11 items-center justify-center rounded-2xl bg-white/5 border border-white/10">
                    <Icon className="h-5 w-5 text-brand-green" />
                </div>
                <div className="font-mono text-xs text-zinc-500">{category.num}</div>
            </div>
            <h3 className="mt-6 font-display text-xl md:text-2xl font-semibold tracking-tight leading-tight">
                {category.name}
            </h3>
            <p className="mt-3 text-[14px] text-zinc-400 leading-relaxed">
                {category.tagline}
            </p>
            <div className="mt-5 flex items-center justify-between text-[12.5px] text-zinc-500">
                <span>{category.offerings.length} sub-practices</span>
                <ArrowUpRight className="h-4 w-4 text-zinc-500 group-hover:text-brand-green group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-all" />
            </div>
        </motion.button>
    );
}
